const Medal = ({
  size,
  color,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4137 15.9447V23.103C14.4138 23.1952 14.3893 23.2857 14.3429 23.3653C14.2966 23.4449 14.2299 23.5108 14.1497 23.5562C14.0695 23.6017 13.9787 23.625 13.8866 23.6239C13.7944 23.6228 13.7042 23.5972 13.6252 23.5499L9.2054 20.8978L4.78561 23.5499C4.70649 23.5973 4.61619 23.6228 4.52396 23.6239C4.43173 23.625 4.34086 23.6015 4.26066 23.556C4.18045 23.5104 4.11379 23.4444 4.06747 23.3646C4.02116 23.2848 3.99687 23.1942 3.99707 23.102V15.9457C2.64931 14.8666 1.66998 13.3956 1.19442 11.7359C0.718868 10.0761 0.770566 8.30966 1.34237 6.68058C1.91418 5.0515 2.97786 3.64025 4.38643 2.64184C5.79499 1.64344 7.47889 1.10718 9.2054 1.10718C10.9319 1.10718 12.6158 1.64344 14.0244 2.64184C15.4329 3.64025 16.4966 5.0515 17.0684 6.68058C17.6402 8.30966 17.6919 10.0761 17.2164 11.7359C16.7408 13.3956 15.7615 14.8666 14.4137 15.9457V15.9447ZM9.2054 15.6895C10.863 15.6895 12.4527 15.031 13.6248 13.8589C14.7969 12.6868 15.4554 11.0971 15.4554 9.43947C15.4554 7.78186 14.7969 6.19215 13.6248 5.02005C12.4527 3.84795 10.863 3.18947 9.2054 3.18947C7.5478 3.18947 5.95809 3.84795 4.78599 5.02005C3.61388 6.19215 2.9554 7.78186 2.9554 9.43947C2.9554 11.0971 3.61388 12.6868 4.78599 13.8589C5.95809 15.031 7.5478 15.6895 9.2054 15.6895ZM9.2054 13.6061C8.10033 13.6061 7.04053 13.1671 6.25913 12.3857C5.47772 11.6043 5.03874 10.5445 5.03874 9.43947C5.03874 8.3344 5.47772 7.27459 6.25913 6.49319C7.04053 5.71179 8.10033 5.2728 9.2054 5.2728C10.3105 5.2728 11.3703 5.71179 12.1517 6.49319C12.9331 7.27459 13.3721 8.3344 13.3721 9.43947C13.3721 10.5445 12.9331 11.6043 12.1517 12.3857C11.3703 13.1671 10.3105 13.6061 9.2054 13.6061Z"
        fill={color}
        stroke="black"
        strokeWidth="0.912903"
      />
    </svg>
  );
};

export default Medal;
